import { string } from 'prop-types';
import React from 'react';

function MandatoryTextForFields({ text }) {
  return (
    <div>
      <small>
        <i>{text}</i>
      </small>
    </div>
  );
}

MandatoryTextForFields.propTypes = {
  text: string.isRequired,
};

export default MandatoryTextForFields;
